<template>
  <div class="layout-configuration">
    <slot name="headerBar" />

    <div class="configuration">
      <div
        :class="{
          'configuration__navigation': true,
          'configuration__navigation--hide': !isMainConfigurationPage(route?.name)
        }"
      >
        <router-link
          v-for="link in panelNavLinks"
          :key="link.locationType"
          activeClass="configuration__navigation-link--active"
          class="configuration__navigation-link"
          :to="{ name: link.name }"
        >
          {{ link.label }}
          <RightArrowIcon class="icon hide-for-medium" />
        </router-link>
      </div>
      <div
        :class="{
          'configuration__panel-content': true,
          'configuration__panel-content--padding': !fullPanel && isDesktop(),
          'configuration__panel-content--height-full-mobile': !fullPanel,
          'configuration__panel-content--hide': isMainConfigurationPage(route?.name)
        }"
      >
        <slot name="panelContent" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

// Utils
import I18n from 'i18n-js';
import { useRoute } from 'vue-router';
import { useShaftV2 } from '@/functions/use_remote_object';
import isDesktop from '@/functions/responsive';
import { isMainConfigurationPage } from '@/functions/configuration';

// Icons
import RightArrowIcon from '@/images/arrow-right.svg';

const route = useRoute();
const currentShaft = useShaftV2({ organisationId: route.params.organisationId, shaftId: route.params.shaftId });

const fullPanel = computed(() => {
  return ['shaftV2ConfigurationShafts'].includes(route.name);
});

const panelNavLinks = computed(() => {
  const links = [
    {
      name: 'shaftV2ConfigurationShafts',
      label: I18n.t('shafts.configuration.shaft.nav'),
    },
    {
      name: 'shaftV2ConfigurationStations',
      label: I18n.t('shafts.configuration.stations.nav'),
    },
  ];

  currentShaft.value?.policy.heavy_mobile_equipment_enabled && links.push({
    name: 'shaftV2ConfigurationHme',
    label: I18n.t('shafts.configuration.heavy_mobile_equipment.nav'),
  });

  return links;
});
</script>
